function imgTagToSvg() {
  $("img.svg").each(function() {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");

    $.get(
      imgURL,
      function(data) {
        var $svg = $(data).find("svg");

        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        $svg = $svg.removeAttr("xmlns:a");

        if (
          !$svg.attr("viewBox") &&
          $svg.attr("height") &&
          $svg.attr("width")
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
          );
        }

        $img.replaceWith($svg);
      },
      "xml"
    );
  });
}

jQuery(document).ready(() => {
  window.onload = function() {
    const preloaderLastTime = 1000;
    setTimeout(function() {
      $("body").addClass("visible");
    }, preloaderLastTime);
    $("#preloader")
      .delay(preloaderLastTime)
      .fadeOut();
  };

  const mailtoUsername = themeVars.mailtoUsername;
  const mailtoDomain = themeVars.mailtoDomain;
  $(".btn-cta").on("click", function(e) {
    e.preventDefault();
    const username = mailtoUsername;
    const domain = mailtoDomain;
    const subject_param = $(this).data("msubj");
    console.log(subject_param);
    window.location.href =
      "mailto:" + username + "@" + domain + "?subject=" + subject_param;
  });

  imgTagToSvg();

  $(".form input, .form textarea")
    .focusin(function() {
      $(this)
        .closest(".gfield")
        .addClass("focus");
    })
    .focusout(function() {
      if (!$(this).val() || $(this).val() === "(___) ___-____") {
        $(this)
          .closest(".gfield")
          .removeClass("focus");
      }
    });

    $('#input_1_5').mask('(999) 999-9999');
});



// WEBPACK FOOTER //
// ./scripts/modules/global.js